<template>
<v-card>
    <v-card-title class="py-3">Venta General</v-card-title>
    <v-card-text v-if="!minimal" class="py-0">
        <GeneralSearch :default="params" @search="search($event)" :loading="loading"/>
    </v-card-text>
    <v-card-text>
        <component :is="reporte" :params="params" :loading.sync="loading"></component>
    </v-card-text>
</v-card>
</template>
<script>
import GeneralSearch from '@components/entities/reporte/venta/general/search';

import Detallado from '@components/entities/reporte/venta/general/detallado';
import Consolidado from '@components/entities/reporte/venta/general/consolidado';
import TicketList from '@components/entities/ticket';

export default {
    components: {
        GeneralSearch,
        Detallado,
        Consolidado,
        TicketList
    },
    props: {
    
    },
    data: function() {
        const query = {... this.$route.query};

        for (const key in query) {
            if (Object.hasOwnProperty.call(query, key)) {
                const element = query[key];
                query[key] = /^-?[\d.]+(?:e-?\d+)?$/.test(element) ? Number.parseFloat(element): element;
            }
        }

        return {
            loading: false,
            params: {
                daterange: [this.$luxon.now().toISODate(),this.$luxon.now().toISODate()],
                ... query,
            },
            minimal: query['minimal'],
        }
    },
    created: function () {
        this.$store.dispatch('ui/layout/setTitle', '');
    },
    computed:{
        reporte: function() {
            if (this.params?.taquilla_id) return 'TicketList';
            if (this.params?.juego_sorteo_id) return 'Detallado';
            return 'Consolidado';    
        },
        divisa: function () {
            return this.$store.getters['persist/divisa/selected'];
        },
    },
    methods:{
        search: function (params) {
            this.params = {
                ... params,
                divisa_id: this.divisa.id,
            };
        }
    },
}
</script>